import { SET_CONTEXT_MENU, HIDE_MENU } from './contextMenuActions'
import { Map } from 'immutable'

const INITIAL_STATE = Map({
    name: HIDE_MENU,
    x: 0,
    y: 0,
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CONTEXT_MENU:
            return state.merge(action.contextMenu)
        default:
            return state
    }
}
